"use client";

import { Zap } from "lucide-react";
import { useState } from "react";

import { SubscriptionPlansModal } from "@/components/subscription-plans-modal";
import { Button } from "@/components/ui/button";
import { useProUser } from "@/contexts/pro-user-context";

export function UpgradeToProButton() {
  const { isPaid } = useProUser();
  const [isModalOpen, setIsModalOpen] = useState(false);

  if (isPaid) return null;

  return (
    <>
      <Button
        onClick={() => setIsModalOpen(true)}
        className="bg-brand-500 hover:bg-brand-600 text-brand-foreground font-semibold md:flex items-center gap-2"
        data-upgrade-button
      >
        <>
          <Zap className="h-4 w-4" />
          <span className="hidden md:block">Upgrade</span>
        </>
      </Button>

      <SubscriptionPlansModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </>
  );
}
